import { connect } from 'react-redux'
import ScreenPreviewComponent from '../components/ScreenPreviewComponent'
import DisplayActions from '../redux/DisplayRedux'

const mapStateToProps = ({ userAccount, display }) => ({
  user: userAccount.user,
  token: userAccount.token,
  customContents: display.customContents,
  defaultContent: display.defaultContent,
  cart: display.cart,
  programmatic: display.programmatic,
  amountBudget: display.amountBudget,
  realAmount: display.realAmount,
  defaultRules: display.defaultRules,
  date_from: display.date_from,
  date_to: display.date_to,
  loadingUploadFile: display.loadingUploadFile,
  fileNew: display.fileNew,
  canva: display.canva,
  audience: display.audience,
  loadingAudience: display.loadingAudience,
  editCampaignActive: display.editCampaignActive,
  reportSingleData: display.reportSingleData,
  totalPromisedShows: display.totalPromisedShows,
  currentCampaign: display.currentCampaign,
  currentDisplay: display.currentDisplay,
  currency: userAccount.currency,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  fetching: display.fetching,
  external_dsp_id: display.external_dsp_id,
  client: display.client,
})

const mapStateToDispatch = (dispatch) => ({
  addCustomContent: (display, displayId, relationId, typePreview) => dispatch(DisplayActions.addCustomContent(display, displayId, relationId, typePreview)),
  toggleFillScreen: (displayId, relationId, value, typePreview) => dispatch(DisplayActions.toggleFillScreen(displayId, relationId, value, typePreview)),
  updateSubsidizedPrice: (relationId, value, typePreview) => dispatch(DisplayActions.updateFieldInCustomContents(relationId, value, "subsidized_price", typePreview)),
  updatePromisedShowsSubsidized: (relationId, value, typePreview) => dispatch(DisplayActions.updateFieldInCustomContents(relationId, value, "promised_shows_subsidized", typePreview)),
  setActive: (relationId, value, typePreview) => dispatch(DisplayActions.updateFieldInCustomContents(relationId, value, "active", typePreview)),
  updateContentName: (relationId, content, value, typePreview) => dispatch(DisplayActions.updateFieldInContent(relationId, content, value, "content_name", typePreview)),
  updateDefaultContent: (content) => dispatch(DisplayActions.updateDefaultContent(content)),
  updateRulesRelationScreen: (displayId, relationId, newRules) => dispatch(DisplayActions.updateRulesRelationScreen(displayId, relationId, newRules)),
  cloneRulesRelationScreen: (rulesToClone) => dispatch(DisplayActions.cloneRulesRelationScreen(rulesToClone)),
  updateImpressionsDisplay: (displayId, relationId, impressions, promised_shows_update_in_transfer, add_max_in_transfer, promised_shows_subsidized) => dispatch(DisplayActions.updateImpressionsDisplay(displayId, relationId, impressions, promised_shows_update_in_transfer, add_max_in_transfer, promised_shows_subsidized)),
  updateCustomContentRequest: (id, displayId, relationId) => dispatch(DisplayActions.updateCustomContentRequest(id, displayId, relationId)),
  updateRealAmount: (realAmount) => dispatch(DisplayActions.updateRealAmount(realAmount)),
  removeDisplayFromCart: (displayId) => dispatch(DisplayActions.removeDisplayFromCart(displayId)),
  removeRelationFromDisplay: (displayId, relationId) => dispatch(DisplayActions.removeRelationFromDisplay(displayId, relationId)),
  editSingleReport: (contentIdOld, contentIdNew, displayId) => dispatch(DisplayActions.editSingleReport(contentIdOld, contentIdNew, displayId)),
  addRelationDisplay: (displayId, relationId, impressions, subsidized_price) => dispatch(DisplayActions.addRelationDisplay(displayId, relationId, impressions, subsidized_price)),
  uploadFileRequest: (file) => dispatch(DisplayActions.uploadFileRequest(file)),
  getAudience: (data) => dispatch(DisplayActions.getAudienceRequest(data)),
  getDisplayInfoRequest: (id, clientId, currency, invoice_issuing_country, external_dsp_id) => dispatch(DisplayActions.getDisplayInfoRequest(id, clientId, currency, invoice_issuing_country, external_dsp_id)),
  removeRelationFromCustomContents: (displayId) => dispatch(DisplayActions.removeRelationFromCustomContents(displayId)),
})

export default connect(mapStateToProps, mapStateToDispatch)(ScreenPreviewComponent)
